import Config from "../constant/Config";
import store from "../redux/Store";
import { updateRoomState, updateSessionState, updateUserState, updateMusicState } from "../redux/Actions";
import { handleRequest } from "../utils";
import { getAccount } from "./AccountService";
import LogRocket from 'logrocket';
import { deleteResource, fetchJsonIfOk } from "./ServiceUtils";

export const createRoom = async (username) => {
  try {
    console.log(`Creating room. [username=${username}]`);
    const url = `${Config.apiurl}/room`;
    const { roomId, roomCode } = await handleRequest("POST", url, "Unable to create room");
    const { userId } = await createUser(username, roomId);
    const joinRoomUrl = `${Config.apiurl}/room/${roomId}/user/${userId}`;
    await handleRequest("POST", joinRoomUrl, "Unable to join room");
    localStorage.setItem("roomId", roomId);
    console.log(`Room created. [roomCode=${roomCode}, roomId=${roomId}]`);
    store.dispatch(updateRoomState({ roomId }));
    store.dispatch(updateSessionState({ roomCode, isLoggedIn: true }));
    const musicState = store.getState().music;
    if (!musicState.isManuallyMuted) {
      store.dispatch(updateMusicState({ isMuted: false }));
    }
    return roomCode;
  } catch (error) {
    console.error(`Failed to create room. [username=${username}]`, error);
    throw error;
  }
}

export const joinRoom = async (roomCode, username) => {
  try {
    console.log(`Joining room. [roomCode=${roomCode}, username=${username}]`);
    const getRoomUrl = `${Config.apiurl}/room?roomCode=${roomCode}`;
    const { roomId } = await handleRequest("GET", getRoomUrl, "Unable to get room to join");
    const { userId } = await createUser(username, roomId);
    const joinRoomUrl = `${Config.apiurl}/room/${roomId}/user/${userId}`;
    await handleRequest("POST", joinRoomUrl, "Unable to join room");
    localStorage.setItem("roomId", roomId);
    store.dispatch(updateRoomState({ roomId }));
    store.dispatch(updateSessionState({ roomCode, isLoggedIn: true }));
  } catch (error) {
    console.error(`Failed to join room. [roomCode=${roomCode}, username=${username}]`, error);
    throw error;
  } 
}

export const getRoom = async (roomId) => {
  return await fetchJsonIfOk(`${Config.apiurl}/room?roomId=${roomId}`);
}

export const removeUserFromRoom = async (roomId, userId) => {
  return await deleteResource(`${Config.apiurl}/room/${roomId}/user/${userId}`);
}

const updateUserIdByRoomId = (userId, roomId) => {
  const originalUserIdByRoomIdJson = localStorage.getItem("userIdByRoomId");
  const userIdByRoomId = originalUserIdByRoomIdJson ? JSON.parse(originalUserIdByRoomIdJson) : {};
  userIdByRoomId[roomId] = userId;
  const userIdByRoomIdJson = JSON.stringify(userIdByRoomId);
  localStorage.setItem("userIdByRoomId", userIdByRoomIdJson);
};

const createUser = async (username, roomId) => {
  try {
    const accountUuid = (await getAccount()).accountUuid;
    const url = `${Config.apiurl}/user/${username}?accountUuid=${accountUuid}`;
    const user = await handleRequest("POST", url, "Unable to create username");
    updateUserIdByRoomId(user.userId, roomId);
    store.dispatch(updateUserState(user));
    LogRocket.identify(accountUuid, { name: username });
    window.newrelic?.setUserId(user.userId);
    return user;
  } catch (error) {
    console.error(`Failed to create user. [username=${username}, roomId=${roomId}]`, error);
    throw error;
  }
}
